import { render, staticRenderFns } from "./vue-wxlogin.vue?vue&type=template&id=82fcb0be&scoped=true&"
import script from "./vue-wxlogin.vue?vue&type=script&lang=js&"
export * from "./vue-wxlogin.vue?vue&type=script&lang=js&"
import style0 from "./vue-wxlogin.vue?vue&type=style&index=0&id=82fcb0be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.4.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82fcb0be",
  null
  
)

component.options.__file = "vue-wxlogin.vue"
export default component.exports